import React from 'react'
import classnames from 'classnames'
import './style.scss'

export interface MenuIconProps {
  active: boolean
  onClick: (active: boolean) => void
}

const MenuIcon: React.FC<MenuIconProps> = ({ active, onClick }) => {
  const handleClick = (): void => {
    onClick(!active)
  }

  return (
    <div
      className={classnames('menu-icon', { active })}
      id="icon"
      onClick={handleClick}
    >
      <div className="icon-1" id="a"></div>
      <div className="icon-2" id="b"></div>
      <div className="icon-3" id="c"></div>
      <div className="clear"></div>
    </div>
  )
}

export default MenuIcon
